import { render } from "./WhatsAppSupportWidget.vue?vue&type=template&id=5868c3e0&scoped=true"
import script from "./WhatsAppSupportWidget.vue?vue&type=script&lang=js"
export * from "./WhatsAppSupportWidget.vue?vue&type=script&lang=js"

import "./WhatsAppSupportWidget.vue?vue&type=style&index=0&id=5868c3e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5868c3e0"]])

export default __exports__